"use strict";

var settings = require('../../../../config/ShinePrintingConfig.json');

module.exports = function (accumulator, order, product, component) {
  if (settings.floralBellyBands.includes(component.wrapper_color)) {
    return accumulator + '-' + component.wrapper_color.replace(' ', '');
  }

  return accumulator + '-Solid-' + component.wrapper_color.replace(' ', '');
};